/* REACT IMPORTS */
import React from "react";
import ReactDOM from "react-dom/client";

/* MATERIAL TAILWIND THEME PROVIDER */
import { ThemeProvider } from "@material-tailwind/react";

/* TOAST NOTIFICATION */
import { ToastContainer } from "react-toast";

/* MAIN APPLICATION */
import Routes from "./routes/routes";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <Routes />
      <ToastContainer position="top-right" delay="5000" />
    </ThemeProvider>
  </React.StrictMode>
);
